import { render, staticRenderFns } from "./DashboardIcons.vue?vue&type=template&id=4a961442&scoped=true&"
import script from "./DashboardIcons.vue?vue&type=script&lang=js&"
export * from "./DashboardIcons.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIcons.vue?vue&type=style&index=0&id=4a961442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a961442",
  null
  
)

export default component.exports